module.exports = __webpack_public_path__ + "img/sapinrouge_off.a27fee19.gif";